module.exports = __webpack_public_path__ + "o.no2.55aa8a0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/o.no2.jpg
// module id = VDln
// module chunks = 0